import React from "react";
import { InvoicePayloadData } from "types/invoice.api";

interface InvoicesBasicInfoProp {
  inVoices?: InvoicePayloadData[];
}
const InvoicesBasicInfo: React.FC<InvoicesBasicInfoProp> = ({ inVoices }) => {
  return (
    <div className="d-flex flex-column p-3 bg-white br-10">
      {/* Title */}
      <div className="fw-medium fs-16 text-black2D font-primary">Invoices</div>

      {/* Border */}
      <div className="border-bottom my-3 mx-n4"></div>
      {(inVoices || []).map((e, i) => (
        <div
          className="d-flex justify-content-between align-items-center gap-2 px-3 py-2 border-dashed border br-7 mb-3"
          key={i}
        >
          <div className="d-flex flex-column gap-1 ">
            <div className="fw-medium fs-12 text-black2D font-primary mt-1 mb-1">
              {e?.reference_number || ""}
            </div>
            <div className="fw-normal fs-12 text-grey89 font-primary mb-1">
              £{e?.price.toFixed(2)}
            </div>
          </div>
          <div className="fw-medium fs-12 text-black2D font-primary bg-greyF5 px-3 py-1 br-4">
            {e?.status}
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(InvoicesBasicInfo);
